// extracted by mini-css-extract-plugin
export default {"header":"header__zdLBR","title-input":"title-input__35UlN"};